'use strict';

bbw.service.AuthUserAvatarSvc = Class({

    $inject: ['$rootScope', 'rpcClient', '$q', '$timeout'],

    $rootScope: undefined,
    $q: undefined,
    $timeout: undefined,
    _rpcClient: undefined,
    _cache: undefined,
    _wired: undefined,
    _onChangedTimeoutPromise: undefined,
    _loading: undefined,

    construct: function($rootScope, rpcClient, $q, $timeout) {
        this.$rootScope = $rootScope;
        this._rpcClient = rpcClient;
        this.$q = $q;
        this.$timeout = $timeout;
        this._cache = {};
        this._wired = {};
        this._loading = {};
        $rootScope.$on(bbw.event.USER_OWN_AVATAR_CHANGED, this._onAvatarChanged.bind(this));
    },

    _onAvatarChanged: function() {
        if (this._onChangedTimeoutPromise) {
            return;
        }
        this._onChangedTimeoutPromise = this.$timeout(function() {
            angular.forEach(this._wired, function(value, size) {
                if (value > 0) {
                    this.get(size, true);
                }
            }.bind(this));
            this._onChangedTimeoutPromise = undefined;
        }.bind(this), 1000);
    },

    get: function(size, reload) {
        if (reload || angular.isUndefined(this._cache[size]) || angular.isUndefined(this._cache[size].ready)) {
            return this._loadAvatar(size).then(this._setAvatar.bind(this, size));
        } else {
            return this.$q.when(this._cache[size]);
        }
    },

    _loadAvatar: function(size) {
        if (angular.isDefined(this._loading[size])) {
            return this._loading[size];
        }

        return this._loading[size] = this._rpcClient.get('user/avatar/' + size).execute().then(function(response) {
            this._loading[size] = undefined;
            return angular.extend({ready: true}, response.avatar);
        }.bind(this));
    },

    _setAvatar: function(size, avatar) {
        if (angular.isUndefined(this._cache[size])) {
            this._cache[size] = avatar;
        } else {
            ngtk.tools.object.replace(this._cache[size], avatar);
        }
        return this._cache[size];
    },

    wireScope: function(scope, key, size) {
        if (angular.isUndefined(this._cache[size])) {
            this._cache[size] = {};
        }
        scope[key] = this._cache[size];
        if (angular.isUndefined(this._wired[size])) {
            this._wired[size] = 0;
        }
        this._wired[size]++;

        scope.$on('$destroy', function() {
            if (this._wired[size] > 0) {
                this._wired[size]--;
            }
        }.bind(this));

        return this.get(size);
    }

});